import React from "react";
import "./style.scss";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import { toEmbeddableLink } from "shared/common-functions";

const CustomCarousel = ({ urlList, isAutoPlay }) => {
  return (
    <Carousel
      className="custom-carousel"
      showIndicators={urlList.length > 1}
      infiniteLoop={true}
      showThumbs={false}
      useKeyboardArrows={true}
      showStatus={false}
      autoPlay={isAutoPlay}>
      {urlList.map((url) => (
        <div className="carousel-item-wrapper" key={url.value}>
          {url.type == "image" && <img src={url.value} />}
          {url.type == "video" && <iframe src={toEmbeddableLink(url.value)} />}
        </div>
      ))}
    </Carousel>
  );
};

export default CustomCarousel;
